<script>
    import { onMount } from 'svelte';
    import MapHome from '../../components/MapHome.svelte';
    import { store } from '../../Store.svelte';
    import AcceptScreen from '../AcceptScreen.svelte';
    import { env } from '../../Environment.svelte';

    const POSSIBLE_STATES = {
        LOADING: 0,
        EDITING_ADDRESS: 1,
        SHOW_OFFERS: 2,
    };

    let state = POSSIBLE_STATES.LOADING;

    function toggleEditAddress() {
        if (state === POSSIBLE_STATES.EDITING_ADDRESS) {
            state = POSSIBLE_STATES.SHOW_OFFERS;
            return;
        }
        if (state === POSSIBLE_STATES.SHOW_OFFERS) {
            state = POSSIBLE_STATES.EDITING_ADDRESS;
            return;
        }
        if (state === POSSIBLE_STATES.ACCEPTING) {
            state = POSSIBLE_STATES.EDITING_ADDRESS;
            return;
        }
    }

    onMount(() => {
        $store.purchaseStatus = env.cleanstore.purchaseStatus;
        $store.requestedServices = env.cleanstore.requestedServices;
        $store.personalDetails = env.cleanstore.personalDetails;
        const isAddressSet =
            $store.requestedAddress.postalCode != null &&
            $store.requestedAddress.postalCode.length > 0 &&
            !$store.requestedAddress.offerError;
        if (isAddressSet) {
            state = POSSIBLE_STATES.SHOW_OFFERS;
            return;
        }
        state = POSSIBLE_STATES.EDITING_ADDRESS;
    });
</script>

{#if state === POSSIBLE_STATES.LOADING}
    <div>loading</div>
{:else if state === POSSIBLE_STATES.EDITING_ADDRESS}
    <MapHome {toggleEditAddress} />
{:else if state === POSSIBLE_STATES.SHOW_OFFERS}
    <slot {toggleEditAddress} />
{/if}
